import React from 'react'

import {connect} from "react-redux"
import {colors} from "../../utils/styles"
import {formatNumber, validateEmailList} from "../../utils/util"

import {DigitalCheckBox} from "./DigitalCheckBox"

const textFieldPromise = import(/* webpackChunkName: "textField" */"@material/react-text-field")
let TextField, Input, HelperText

const headerStyle = {
  height: 35,
  fontWeight: 700,
  fontSize: 14,
  backgroundColor: colors.mocTableHeaderBg,
  color: colors.grayDark,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  filter: 'drop-shadow(0 1px 3px rgba(11, 11, 13, 0.25))'
}

export class DigitalPaymentInfoBox extends React.Component {
  constructor(props) {
    super(props)
    let receipt = localStorage.getItem('includeReceipt')
    if (receipt === null) {
      receipt = false
    } else {
      receipt = (receipt === 'true')
    }
    this.state = {
      email: props.userprofile ? props.userprofile.email : '',
      sendEmail: true,
      includeReceipt: receipt,
      emailfocus: false,
      customerRef: ""
    }
    this.waitForImports()
  }

  async waitForImports() {
    TextField = (await textFieldPromise).default
    Input = (await textFieldPromise).Input
    HelperText = (await textFieldPromise).HelperText
    this.setState({loaded: true})
  }

  handleValueChange(field, event) {
    if (this.props.disabled) {
      return
    }
    const value = event.target.value || ''
    const newState = {
      [field]: value
    }
    if (field === 'sendEmail') {
      newState.sendEmail = !this.state.sendEmail
      if (!newState.sendEmail) {
        newState.includeReceipt = false
      }
    }
    if (field === 'includeReceipt') {
      newState.includeReceipt = !this.state.includeReceipt
      localStorage.setItem('includeReceipt', newState.includeReceipt)
      if (newState.includeReceipt) {
        newState.sendEmail = true
      }
    }

    this.setState(newState, () => {
      if (this.props.onChange) {
        this.props.onChange(value)
      }
    })
  }

  isValid() {
    return !this.state.sendEmail || this.isEmailValid()
  }

  emailToSend() {
    return this.state.sendEmail ? this.state.email : null
  }

  includeReceipt() {
    return this.state.includeReceipt
  }

  getCustomerRefNum() {
    return this.state.customerRef
  }

  getTotalCharge() {
    return formatNumber(this.props.totalOutstanding)
  }

  getEmailhelperText() {
    if (!this.state.email || !this.state.emailfocus) {
      return null
    }
    if (validateEmailList(this.state.email)) {
      return <HelperText persistent>Separate multiple email addresses with a comma “,”</HelperText>
    } else {
      return <HelperText validation={true} persistent>Check email format</HelperText>
    }
  }

  isEmailValid() {
    return !this.state.sendEmail || validateEmailList(this.state.email)
  }

  handleFocus(field, focus) {
    this.setState({[field + 'focus']: focus})
  }

  renderTextField(classname, label, textColor, fontWeight, value) {
    return (
        <div style={{marginRight: 20}}>
          <TextField
              id={classname}
              label={label}
              style={{height: 44, width: 180}}
          >
            <Input
                id={classname + '-input'}
                style={{
                  fontSize: 14,
                  color: textColor,
                  fontWeight: fontWeight,
                  borderBottomColor: 'transparent'
                }}
                value={value}
                readOnly={true}
            />
          </TextField>
        </div>
    )
  }

  render() {
    if (!TextField) {
      return null
    }
    const fullMode = this.props.fullMode
    return (
        <div style={{display: 'flex', flexDirection: 'row', fontFamily: 'Arial'}}>
          {fullMode && <div style={{border: 'solid 0.3px #d8d8d8', width: '100%'}} className="notify-info">
            <div style={headerStyle}>
              <div style={{marginLeft: 20}}>NOTIFICATION INFORMATION</div>
            </div>
            <div style={{padding: '10px 20px', minHeight: 178}}>
              {this.getCustomerRefInput()}
              {this.getEmail()}
            </div>
          </div>}
          {fullMode && <div style={{width: 20}}/>}
          <div style={{border: 'solid 0.3px #d8d8d8', width: '100%'}} className="payment-info">
            <div style={headerStyle}>
              <div style={{marginLeft: 20}}>PAYMENT INFORMATION</div>
            </div>
            <div style={{padding: '0px 20px'}}>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingTop: 10
              }}>
                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                  {this.props.displayReefer && this.renderTextField(
                      'totalDemCharges',
                      'Total Demurrage Charges',
                      colors.mocText,
                      400,
                      formatNumber(this.props.totalDemCharges) + ' ' + this.props.currency, 209)}
                  {this.props.displayReefer && this.renderTextField(
                      'totalRmcCharges',
                      'Total Reefer Monitoring Charges',
                      colors.mocText,
                      400,
                      formatNumber(this.props.totalRmcCharges) + ' ' + this.props.currency, 209)}
                  {this.renderTextField(
                      'totalCharges',
                      this.props.displayReefer ? 'Total Charges' : 'Total Demurrage Charges',
                      colors.mocText,
                      400,
                      formatNumber(this.props.totalCharges) + ' ' + this.props.currency, 209)}
                  {this.renderTextField(
                      'totalPaid',
                      'Total Paid',
                      colors.mocText,
                      400,
                      formatNumber(this.props.totalPaid) + ' ' + this.props.currency)}
                  {this.renderTextField(
                      'totalOutstanding',
                      'Total Outstanding',
                      colors.mocBrandPrimary,
                      700,
                      this.getTotalCharge() + ' ' + this.props.currency)}
                </div>
              </div>
              {this.props.showEmail && this.getEmail()}
            </div>
          </div>
        </div>
    )
  }

  getCustomerRefInput() {
    return (this.props.showCustomerRef) ? (
        <TextField className={'customer-reference'}
                   label={'Customer Reference Number'}
                   style={{width: 300}}
                   helperText={<HelperText>This reference number will reflect on your payment
                     transaction.</HelperText>}
        >
          <Input style={{fontSize: '16px', color: colors.offBlack}}
                 value={this.state.customerRef}
                 onChange={this.handleValueChange.bind(this, 'customerRef')}
                 onFocus={this.handleFocus.bind(this, 'customerRef', true)}
                 onBlur={this.handleFocus.bind(this, 'customerRef', false)}
                 disabled={this.props.disabled}
                 maxLength={200}
          />
        </TextField>
    ) : null
  }

  getEmail() {
    return <React.Fragment>
      <DigitalCheckBox isChecked={this.state.sendEmail}
                classNameToUse={'sendEmail-cb'}
                isEnabled={!this.props.disabled}
                handleClick={this.handleValueChange.bind(this, 'sendEmail')}
                label={'Send email confirmation(s) for your transaction record'}/>
      <DigitalCheckBox isChecked={this.state.includeReceipt}
                style={{marginLeft: 25}}
                classNameToUse={'includeReceipt-cb'}
                isEnabled={!this.props.disabled}
                handleClick={this.handleValueChange.bind(this, 'includeReceipt')}
                label={'Include official receipt'}/>
      <TextField className={'email-addr'}
                 label={'Email Recipients'}
                 helperText={this.getEmailhelperText()}
                 style={{width: 600, marginTop: 10}}
      >
        <Input style={{fontSize: '16px', color: colors.offBlack}}
               value={this.state.email}
               isValid={this.isEmailValid()}
               onChange={this.handleValueChange.bind(this, 'email')}
               onFocus={this.handleFocus.bind(this, 'email', true)}
               onBlur={this.handleFocus.bind(this, 'email', false)}
               maxLength={200}
               disabled={!this.state.sendEmail || this.props.disabled}
        />
      </TextField>
    </React.Fragment>
  }
}

function mapStateToProps(state) {
  return {
    userprofile: state.userProfile
  }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(DigitalPaymentInfoBox)